(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    const dw = document.getElementById('dw');
  const sc = document.getElementById('sc');
  const bg = document.getElementById('bg');

  const setDrawer = (open) => {
    dw.classList.toggle('on', open);
    sc.classList.toggle('on', open);
    if (bg) bg.setAttribute('aria-expanded', String(open));
  };

  const dwc = document.getElementById('dwc');

  if (bg) bg.onclick = () => setDrawer(true);
  if (dwc) dwc.onclick = () => setDrawer(false);
  sc.onclick = () => setDrawer(false);
  dw.querySelectorAll('a').forEach((a) => (a.onclick = () => setDrawer(false)));
  addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setDrawer(false);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nld-language-selector"] && !Shopify.designMode) return;
  try {
    /* `<details>` closes on its own summary but has no notion of an outside
     click or of Escape, which a header disclosure is expected to honour.
     Bound once at document level so it covers both pickers and survives a
     section re-render in the theme editor. */
  (() => {
    if (window.nldLangSelectorBound) return;
    window.nldLangSelectorBound = true;

    const closeAll = (except) => {
      document.querySelectorAll('details.lang[open]').forEach((el) => {
        if (el !== except) el.open = false;
      });
    };

    document.addEventListener('pointerdown', (event) => {
      const open = document.querySelector('details.lang[open]');
      if (open && !open.contains(event.target)) closeAll();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = document.querySelector('details.lang[open]');
      if (!open) return;
      open.open = false;
      open.querySelector('summary').focus();
    });

    /* One open at a time, so the drawer picker does not sit open behind the
       header one on a tablet width where both are reachable. */
    document.addEventListener('toggle', (event) => {
      const el = event.target;
      if (el instanceof HTMLDetailsElement && el.classList.contains('lang') && el.open) closeAll(el);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
